import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/merchant-banner.png'


const _hoisted_1 = { class: "order" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "hero-image"
}, null, -1)
const _hoisted_3 = { class: "order-card-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_order_info = _resolveComponent("order-info")!
  const _component_payment_footer_sticky = _resolveComponent("payment-footer-sticky")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_order_info, {
        order: _ctx.order.order
      }, null, 8, ["order"])
    ]),
    _createVNode(_component_payment_footer_sticky, {
      order: _ctx.order.order,
      sticky: true
    }, null, 8, ["order"])
  ]))
}